<!--
 * @Author: lbh
 * @Date: 2021-05-18 18:16:28
 * @LastEditors: lbh
 * @LastEditTime: 2021-05-18 18:31:49
 * @Description: file content
-->
<template>
  <div
    class="self_nav-bar van-nav-bar van-nav-bar--fixed van-hairline--bottom"
    style="z-index: 100;"
    :class=" color ? 'self_bg_color' :  '' "
    :style="{ backgroundColor: color ? color : '#FFF', color: color ? '#fff' : '#5f5f5f' }"
  >
    <div class="van-nav-bar__left">
      <van-icon
        size="20"
        @click="backFn"
        :color="color ? '#fff' : '#5f5f5f'"
        v-if="back"
        slot="left"
        name="arrow-left"
      />
      <!-- <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" @click="backFn()"></i> -->
    </div>
    <div class="self-nav-body">
      <img
        class="cell-logo self-logo"
        v-if="!title && !flag"
        :src="themeLogo"
        alt=""
        slot="title"
      />
      <img
        class="cell-logo self-logo"
        v-if="!title && flag"
        :src="themeLogo"
        alt=""
        slot="title"
      />
    </div>
    <div
      class="van-nav-bar__right"
      @click="rightC"
    >
      <span :style="'color:'+ (select == 1 ? sel_color : '#969799')"> {{ r_title1 }}</span>
      /
      <span :style="'color:'+ (select == 2 ? sel_color : '#969799')">{{ r_title2 }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headNave',
  data () {
    return {
      value: 0 // 父組件傳入到子組件的值, 不允許在子組件內修改, 所以需要定義一個 value 替換 value_
    };
  },
  methods: {
    backFn () {
      this.$router.back();
    },
    islogin () {
      this.$emit('rightClick');
    }
  },
  mounted () {
    console.log(this.$refs.headNavs);
    // 設置頭部標題
    // if (this.title) this.$refs.headNavs.querySelector('.van-nav-bar__title').style.color = this.color ? '#fff' : '#5f5f5f';
    // if (this.back && this.color) this.$refs.headNavs.querySelector('.van-icon-arrow-left').style.color = this.color ? '#fff' : '#5f5f5f';
  },
  props: ['back', 'color', 'title', 'flag', 'r_title1', 'r_title2', 'sel_color', 'select', 'rightC']
};
</script>
<style scoped>
.self_nav-bar {
  height: 46px;
}
.van-dropdown-menu__title {
  color: #fff !important;
}

[class*="van-hairline"]:after {
  border-width: 0 !important;
}

.self-nav-body {
  max-width: 60%;
  margin-left: 20%;
  /* height: 100%; */
}

.cell-logo {
  max-width: 100%;
  /*height: 100%;*/
  /* padding: 20px 0 */
}

.self-logo {
  height: 40px;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/headNave.vue